"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Response = void 0;
const utils_1 = require("../../utils");
class Response {
    constructor({ url, status, statusText, headers, mimeType, encodedDataLength, }) {
        this.connectionReused = false;
        this.securityState = 'secure';
        this.url = url;
        this.status = status;
        this.statusText = statusText;
        this.headers = headers;
        this.mimeType = mimeType;
        this.encodedDataLength = encodedDataLength;
        this.connectionId = (0, utils_1.randomNumId)();
    }
}
exports.Response = Response;
